import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class InitiativesCount extends Field {
  static availableForModel(modelClass, recordLayout) {
    if (!['Goal'].includes(modelClass.typename)) {
      return false;
    }

    return super.availableForModel(modelClass, recordLayout);
  }

  static attributesForModel() {
    return ['initiativesCount'];
  }

  get title() {
    return `${terminology('Initiatives')} count`;
  }

  exampleContents(): FieldContentsData {
    return { text: `3 ${terminology('initiatives')}` };
  }

  contentsForRecord(record): FieldContentsData {
    return {
      text: `${record.initiativesCount} ${terminology('initiatives', {
        isPlural: record.initiativesCount > 1,
      })}`,
    };
  }
}
